import React, {Component} from 'react'
import DateColumn from './column/DateColumn'
import BarcodeColumn from './column/BarcodeColumn'
import PropTypes from 'prop-types'
import ErrorTypeColumn from './column/ErrorTypeColumn'
import ErrorDetailColumn from './column/ErrorDetailColumn'
import PrinterColumn from './column/PrinterColumn'
import MarkerColumn from './column/MarkerColumn'

class TableRow extends Component {
    render() {
        const {item} = this.props
        const {barcode, sku, error_reason, printer, created, checker} = item
        const error_type = error_reason ? error_reason.error_type : ''
        const error_detail = error_reason ? error_reason.error_detail : []
        const name = printer ? printer.name : ''
        const side = printer ? printer.side : []

        return (
            <tr className="TableRow">
                <BarcodeColumn barcode={barcode}/>
                <td className="sku">{sku}</td>
                <ErrorTypeColumn errorType={error_type}/>
                <ErrorDetailColumn errorDetail={error_detail}/>
                <PrinterColumn printer={printer}/>
                <DateColumn created={created}/>
                <MarkerColumn marker={checker}/>
            </tr>
        )
    }
}

TableRow.propTypes = {
    item: PropTypes.object
}

export default TableRow